import React from 'react';
import { Avatar, Box, Tooltip, Typography } from '@mui/material';

import {
  getOrganizationMemberIfLoaded,
  getUnknownUser,
  getUserDisplayName,
  getUserInitials,
  NamedUser,
} from '@paragon/login-tools';

import { useAppSelector } from './hooks';

export function UserAvatar({ user, ...props }: { readonly user: NamedUser } & React.ComponentProps<typeof Avatar>) {
  return (
    <Avatar {...props} sx={{ width: 24, height: 24, fontSize: 11, flexShrink: 0 }}>
      {getUserInitials(user)}
    </Avatar>
  );
}

interface Props {
  readonly assigneeEmail: string | null;
}

export function AssigneeAvatar({ assigneeEmail }: Props) {
  const member = useAppSelector((state) =>
    assigneeEmail == null ? undefined : getOrganizationMemberIfLoaded(state, assigneeEmail),
  );

  if (!assigneeEmail) {
    return (
      <Typography component="span" variant="body2" color="text.disabled" aria-label="Unassigned">
        —
      </Typography>
    );
  }

  const assignee = member ?? getUnknownUser(assigneeEmail);
  const label = getUserDisplayName(assignee);

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
      <Tooltip title={assigneeEmail}>
        <UserAvatar user={assignee} />
      </Tooltip>
      <Typography component="span" variant="body2" noWrap title={label}>
        {label}
      </Typography>
    </Box>
  );
}
